module.exports = __webpack_public_path__ + "static/generic-family-8134095b9ab59636337ddfb13d9f4e30.jpg";